import { AutoComplete } from "primereact/autocomplete";
import { Calendar } from "primereact/calendar";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import React, { useEffect, useState } from "react";
import { createAPIEndpointBulkInvGen, EndpointBulkInvGen } from "../../Services/BulkInvoiceGeneration/BulkInvoiceGenerationService";
import { format } from "date-fns";
import storage from "../../Services/Storage";
import { toast } from "react-toastify";
import { useGlobalContext1 } from "../../context/SalesDetailsContext";
import Print from "../InvoicePrint/NewPrintInvoice";
import Loader from "../../Components/Loader";

const BulkInvoiceGeneration = () => {
    const auth = storage.getLocal("user");
    const [startDate, setStartDate] = useState(() => {
        let date = new Date();
        date.setDate(date.getDate() - 7);
        return date;
    });
    const [endDate, setEndDate] = useState(new Date());
    const [allCustSugg, setAllCustSugg] = useState([]);
    const [allCust, setAllCust] = useState([]);
    const currentDate = format(new Date(), "dd/MM/yyyy");
    const [selectedAllCust, setSelectedAllCust] = useState([]);
    const [allSalesOrder, setAllSalesOrder] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedSalesOrder, setSelectedSalesOrder] = useState([]);
    const { invoicePopup, setInvoicePopup, setPrintInvoiceModalData } = useGlobalContext1();

    const printInvoiceCall = async (row) => {
        const objInvoice = [{
            CICode: auth.CICode,
            InvoiceId: row,
            CompId: auth.CompId,
            EInvPaymentUPI: auth.EInvPaymentUPI,
            InvoiceDate: currentDate,
            DistTag: auth.DistTag,
            EInvApplicability: auth.EInvApplicability,
            EInvB2CQR: auth.EInvB2CQR,
        }];
        setPrintInvoiceModalData(objInvoice);
        setInvoicePopup(true);
    };

    const pageLoad = () => {
        setLoading(true);
        createAPIEndpointBulkInvGen()
            .get(`${EndpointBulkInvGen.GetCustforBulkInv}?FromDate=${format(startDate, "dd/MM/yyyy")}&ToDate=${format(endDate, "dd/MM/yyyy")}&CompId=${auth.CompId}`)
            .then((res) => {
                if(res?.data==="No Data Found"){
                    setAllCustSugg([]);
                }
                else{
                    setAllCustSugg(res.data);
                }
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                console.log("Error", e);
            });
    };

    useEffect(() => {
        pageLoad();
    }, []);


    const searchCustomer = (e) => {
        setTimeout(() => {
            let _filteredCustomer;
            if (!e.query?.trim().length) {
                _filteredCustomer = [...allCustSugg];
            } else {
                _filteredCustomer = allCustSugg.filter((customer) => {
                    return (
                        customer.CODE.toLowerCase().includes(
                            e.query.toLowerCase()
                        ) ||
                        customer.NAME.toLowerCase().includes(e.query.toLowerCase())
                    );
                });
            }
            setAllCust(_filteredCustomer);
        }, 250);
    };

    const itemTemplate = (item) => <div>{item.NAME}</div>;

    const handleCustSelect = (e) => {
        setLoading(true);
        createAPIEndpointBulkInvGen()
            .get(`${EndpointBulkInvGen.PopulateSalesOrdersGrid}?FromDate=${format(startDate, "dd/MM/yyyy")}&ToDate=${format(endDate, "dd/MM/yyyy")}&LangId=1&UserId=${auth.UserId}&strCustId=${encodeURIComponent(e?.MASK_CUST_ID)}`)
            .then((res) => {
                if(res?.data==="No Data Found"){
                    setAllSalesOrder([]);
                }
                else{
                    setAllSalesOrder(res.data);
                }
                setLoading(false);
            })
            .catch((e) => {
                setLoading(false);
                console.log("Error", e);
            });
    };

    console.log("auth", auth);
    console.log("auth", selectedSalesOrder);

    const handleCreateInvoice = () => {
        if ((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24) > 31) {
            toast.warn("Date range is greater than 31.", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
        }
        else if(selectedSalesOrder.length<2){
            toast.warn("Select atleast two sales order.", {
                position: toast.POSITION.TOP_CENTER,
                pauseOnFocusLoss: false,
                closeButton: false,
                autoClose: 3000,
            });
        }
        else {
            const maskListObj = selectedSalesOrder.map((val) => (
                {
                    sohD_ID: val.SOHD_ID,
                    sohD_SO_NO: val.SOHD_SO_NO,
                    sohD_SO_DATE: val.SOHD_SO_DATE,
                    masK_SOHD_TOT_AMT: val?.MASK_SOHD_TOT_AMT
                }
            ));

            const obj = {
                compId: auth.CompId,
                userId: auth.UserId,
                custId: selectedAllCust?.MASK_CUST_ID,
                eInvApplicability: auth.EInvApplicability,
                eInvIRPUserId: auth.EInvIRPUserId,
                eInvIRPUserPassword: auth.EInvIRPUserPassword,
                eInvGSTNO: auth.EInvGSTNO,
                lstInv: maskListObj
            };
            console.log("first", obj);
            // return
            setLoading(true);

            createAPIEndpointBulkInvGen()
                .post(`${EndpointBulkInvGen.Save}`, obj)
                .then((val) => {
                    console.log("firstOkay");

                    toast.success(`${val.data.Message}`, {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 3000,
                    });
                    createAPIEndpointBulkInvGen()
                        .get(`${EndpointBulkInvGen.PopulateSalesOrdersGrid}?FromDate=${format(startDate, "dd/MM/yyyy")}&ToDate=${format(endDate, "dd/MM/yyyy")}&LangId=1&UserId=${auth.UserId}&strCustId=${selectedAllCust?.MASK_CUST_ID}`)
                        .then((res) => {
                            if(res?.data==="No Data Found"){
                                setAllSalesOrder([]);
                            }
                            else{
                                setAllSalesOrder(res.data);
                            }
                            setLoading(false);
                        })
                        .catch((e) => {
                            setLoading(false);
                            console.log("Error", e);
                        });
                    setLoading(false);

                    if (val.data?.Status == "Success") {
                        printInvoiceCall(val?.data?.Data.InvhId);
                    }
                })
                .catch((e) => {
                    toast.error(`${e.response.data?.Message}`, {
                        position: toast.POSITION.TOP_CENTER,
                        pauseOnFocusLoss: false,
                        closeButton: false,
                        autoClose: 3000,
                    });
                    setLoading(false);

                });
        }
    };

    if (loading) {
        return (
            <>
                <Loader />
            </>
        );
    }
    else {
        return (
            <>
                <div className="col-12 pt-0 pb-4">
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <h3 className="py-2">Bulk Invoice Generation</h3>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">

                        </div>
                    </div>
                    <section className="sales-box">
                        <div className='row d-flex justify-content-end align-items-end'>
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <label className="form-label">From Date</label>
                                <Calendar value={startDate}
                                    onChange={(e) => setStartDate(e.value)}
                                    showIcon
                                    dateFormat="dd/mm/yy" />
                            </div>
                            <div className="col-lg-4 col-md-4 col-sm-12">
                                <label className="form-label">To Date</label>
                                <Calendar value={endDate}
                                    onChange={(e) => setEndDate(e.value)}
                                    showIcon
                                    dateFormat="dd/mm/yy" />
                            </div>
                            <div className='col-lg-4 col-md-6 col-sm-12'>
                                <div className="text-end">
                                    <button type="button" className="btn btn-primary" onClick={() => { pageLoad(); }}>Get Customer</button>
                                </div>
                            </div>
                        </div>
                    </section >

                    <section className="sales-box">
                        <div className='row d-flex justify-content-end align-items-end'>
                            <div className='col-lg-6 col-md-6 col-sm-12'>
                                <label className="form-label">Customer Name</label>
                                <AutoComplete
                                    dropdown
                                    field="NAME"
                                    value={selectedAllCust}
                                    suggestions={allCust}
                                    completeMethod={searchCustomer}
                                    onChange={(e) => {
                                        setSelectedAllCust(e.value);
                                    }}
                                    itemTemplate={itemTemplate}
                                    forceSelection={true}
                                    emptyMessage="No Customer found"
                                    onSelect={(e) => handleCustSelect(e.value)}
                                />
                            </div>
                            <div className='col-lg-6 col-md-6 col-sm-12'>
                                <div className="text-end">
                                    <button type="button" className="btn btn-outline-primary" onClick={handleCreateInvoice}>Create Invoice</button>
                                </div>
                            </div>
                        </div>
                        <div className="DataTable pt-3">

                            <DataTable
                                value={allSalesOrder}
                                rows={10}
                                filterDisplay="row"
                                // showGridlines
                                stripedRows
                                scrollHeight="80vh"
                                scrollable
                                paginator
                                selection={selectedSalesOrder}
                                onSelectionChange={(e) => setSelectedSalesOrder(e.value)}
                                selectionMode="checkbox"
                            // selectAll={false}
                            >
                                <Column selectionMode="multiple" header="Select All" headerStyle={{ width: "10rem" }}></Column>
                                <Column field="SOHD_SO_NO" header="Sales Order Number" />
                                <Column field="SOHD_SO_DATE" header="Sales Order Date" />
                            </DataTable>
                        </div>
                    </section>
                    {invoicePopup ? <Print /> : null}
                </div >
            </>
        );
    }

};

export default BulkInvoiceGeneration;